const { gql } = require('graphql-tag');

const ChannelFragment = require('../channelFragment').fragment;
const InitiatorFragment = require('../initiatorFragment').fragment;

module.exports = {
  fragment: gql`
    ${ChannelFragment}
    ${InitiatorFragment}

    fragment StoreFragment on Store {
      id
      version
      key
      languages
      createdAt
      lastModifiedAt
      name (locale: $locale)
      nameAllLocales {
        value
        locale
      }
      distributionChannels {
        ...ChannelFragment
      }
      supplyChannels {
        ...ChannelFragment
      }
      createdBy {
        ...InitiatorFragment
      }
      lastModifiedBy {
        ...InitiatorFragment
      }
      custom {
        customFieldsRaw {
          name
          value
        }
      }
    }
  `,
};
